import { AppDispatch } from '@Store';
import { messaging, getToken, onMessage } from './firebase';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import {
  getAllReadNotifications,
  getAllUnreadNotifications,
  putNotificationToken,
} from '@Reducers/Notifications/actions';
import dayjs from 'dayjs';
import { addNotification } from '@Reducers/FirebaseNotifications/notificationSlice';
import { setIsDrawerOpen } from '@Reducers/notificationState/notificationState';
import { getBulkOrderSummaryList } from '@Reducers/BulkOrderSummary';
import moment from 'moment';

export const requestNotificationPermission = async (dispatch: AppDispatch, limit: number) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      // console.info('✅ Notification permission granted.');

      const token = await getToken(messaging, {
        vapidKey: 'BFtZC19NSUOEApTw790BdyP9kw0ihk6AEj1RXJg0RasQrwvmSvq-XszvdFDNuhk1ZqKbbGHyeOA_8RYWXz3diaM',
      });

      if (token) {
        console.info('📲 FCM Token:', token);
        dispatch(putNotificationToken({ fcmWebToken: token }));
      } else {
        console.warn('⚠️ No registration token available.');
      }

      // ✅ Listen for foreground messages
      onMessage(messaging, payload => {
        // console.info('🔔 Foreground message received:', payload);

        const { title, body } = payload.notification || {};
        const notification = {
          title: title || 'Notification',
          body: body || 'Success',
          timestamp: dayjs().toISOString(),
        };

        // Save in Redux
        dispatch(addNotification(notification));

        const lowerCaseTitle = notification.title?.toLowerCase();

        // Handle specific cases with SuccessErrorModal
        if (lowerCaseTitle === 'bulk upload completed' || lowerCaseTitle === 'access group updated') {
          dispatch(
            SuccessErrorModalOpen({
              type: 'success',
              title: notification.title,
              subTitle: lowerCaseTitle === 'bulk upload completed' ? 'Your file has been uploaded' : notification.body,
              onConfirm:
                lowerCaseTitle === 'access group updated'
                  ? () => window.location.reload()
                  : lowerCaseTitle === 'bulk upload completed'
                  ? () => {
                      dispatch(setIsDrawerOpen(true));
                      dispatch(
                        getBulkOrderSummaryList({
                          currentPage: 1,
                          perPage: 10,
                          fromDate: moment().subtract(1, 'months').startOf('day').format('DD/MM/YYYY'),
                          toDate: moment().endOf('day').format('DD/MM/YYYY'),
                        }),
                      );
                      dispatch(SuccessErrorModalReset());
                    }
                  : undefined,
            }),
          );
        }

        dispatch(
          getAllUnreadNotifications({
            page: 1,
            limit,
          }),
        );
        dispatch(getAllReadNotifications({ page: 1, limit }));
      });
    } else {
      console.warn('🚫 Notification permission denied');
    }
  } catch (error) {
    console.error('❌ Error while requesting permission or retrieving token:', error);
  }
};
